module.exports = __webpack_public_path__ + "static/media/noItemsAfterFilter.36a1bd1e.jpg";